import React from "react";
export default function LoadingSpinner() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh", // Full viewport height
        width: "100%", // Full width
        position: "fixed",
        top: 0,
        left: 0,
        backgroundColor: "white", // Optional: light overlay
        zIndex: 9999, // Ensure it's on top of other content
      }}
    >
      <div
        style={{
          border: "4px solid rgba(0, 0, 0, 0.1)", // Light border
          borderTop: "4px solid #3498db", // Blue border
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          animation: "spin 1s linear infinite",
        }}
      />
      {/* Add keyframes directly in a <style> tag */}
      <style>
        {`
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </div>
  );
}
